import { Typography } from '@material-ui/core';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ReactComponent as PowerBILogo } from '../../../assets/icons/powerbi-logo.svg';

const CustomSubtitle = withStyles({
  root: {
    color: 'black',
    marginBottom: '10px',
    textAlign: 'center',
  },
})(Typography);

const PowerBIForm = ({ intl }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <form
        style={{
          width: '50%',
          height: '40%',
          backgroundColor: 'white',
          padding: '22px 20px',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            marginBottom: '15px',
          }}
        >
          <PowerBILogo width={75} height={75} />
        </div>

        <CustomSubtitle variant="h5">
          {intl.messages['powerbi.layout.title1']}
        </CustomSubtitle>

        <CustomSubtitle variant="subtitle1" color="textSecondary">
          {intl.messages['powerbi.layout.title2']}
        </CustomSubtitle>
      </form>
    </div>
  );
};

export default PowerBIForm;
